"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useGetHasAcknowledgedByActivityKey = _interopRequireDefault(require("../providers/ActivityAcknowledgement/useGetHasAcknowledgedByActivityKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _useGetHasAcknowledgedByActivityKey.default;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VHZXRIYXNBY2tub3dsZWRnZWRCeUFjdGl2aXR5S2V5Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlR2V0SGFzQWNrbm93bGVkZ2VkQnlBY3Rpdml0eUtleS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlR2V0SGFzQWNrbm93bGVkZ2VkQnlBY3Rpdml0eUtleSBmcm9tICcuLi9wcm92aWRlcnMvQWN0aXZpdHlBY2tub3dsZWRnZW1lbnQvdXNlR2V0SGFzQWNrbm93bGVkZ2VkQnlBY3Rpdml0eUtleSc7XG5cbmV4cG9ydCBkZWZhdWx0IHVzZUdldEhhc0Fja25vd2xlZGdlZEJ5QWN0aXZpdHlLZXk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztlQUVlQSwyQyJ9